/*
 * @Author: liuxiuting
 * @Date: 2022-05-06 15:53:56
 * @LastEditors: liuxiuting
 * @LastEditTime: 2024-03-15 16:01:12
 * @FilePath: \carrier\packages\common-mediax\src\apis\MediaCloudArticleOrigin\Permission.js
 * @Description: 
 * 
 * Copyright (c) 2024 by 用户/公司名, All Rights Reserved. 
 */
import { createAPI } from "../../common";

export default {
  postPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0f60benjo0qfsnjttjpot0bdujpot0gpmefs', 'post', config),
  getPermissionAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0f60benjo0qfsnjttjpot0bdujpot0gpmefs', 'get', config),
  // 查看权限 待办
  getAssignStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0bsujdmft0bttjho0tubuvt', 'get', config),
  // 查看权限消息
  getDetailStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0bsujdmft0efubjm0tubuvt', 'get', config)
}
